const helpDeskEn = {
    ticket: require('lang/en/help_desk/Ticket').default,
    findService: require('lang/en/help_desk/FindService').default,
    sos: require('lang/en/help_desk/Sos').default,
}

export default helpDeskEn;